import { useEffect, useState } from 'react';

import { useAppSelector } from '../store/hooks';
import { createBankBin, createMaskedPan } from '../utils/create-masked-pan';

export type CardOptionType = {
  crypt?: string;
  maskedPan: string;
  bankBin?: string;
  newCard?: boolean;
  name?: string;
  id: number;
};

type CardType = {
  crypt: string;
  pan: string;
  name?: string;
};

const defaulValue = { id: 0, maskedPan: 'Новая карта', newCard: true };

const useSelectCard = (lsName?: string) => {
  const paymentCards = lsName ?? 'cards';
  const { isPayment } = useAppSelector((state) => state.payment);
  const [cards, setCards] = useState<CardOptionType[]>([]);
  const [selectedCard, setSelectedCard] = useState<CardOptionType>(defaulValue);

  useEffect(() => {
    const cadsLS = isPayment
      ? localStorage.getItem(paymentCards)
      : localStorage.getItem('simpleCards');

    if (cadsLS) {
      const parseCards = JSON.parse(cadsLS);
      setCards(parseCards);

      const lastItem = parseCards[parseCards.length - 1];

      if (lastItem) {
        setSelectedCard(lastItem);
      }
    }
  }, [isPayment, paymentCards]);

  const addCard = async (cardData: CardType) => {
    const copyCards = [...cards];

    const newItem = {
      id: copyCards.length + 1,
      crypt: cardData.crypt,
      maskedPan: createMaskedPan(cardData.pan),
      bankBin: createBankBin(cardData.pan),
      name: cardData.name,
    };

    const updateCards = [...copyCards, newItem];

    if (updateCards) {
      localStorage.setItem(isPayment ? paymentCards : 'simpleCards', JSON.stringify(updateCards));
      setCards(updateCards);
    }
  };

  const updateCardName = (id: number, name: string) => {
    const updatedCards = cards.map((card) =>
      card.id === id ? { ...card, name } : card,
    );
    localStorage.setItem(isPayment ? paymentCards : 'simpleCards', JSON.stringify(updatedCards));
    setCards(updatedCards);
  };

  const removeCard = (pan: string) => {
    const updatedCards = cards.filter((card) => card.maskedPan !== pan);

    localStorage.setItem(isPayment ? paymentCards : 'simpleCards', JSON.stringify(updatedCards));

    setCards(updatedCards);
    setSelectedCard(defaulValue);
  };

  return {
    addCard,
    updateCardName,
    removeCard,
    setCards,
    setSelectedCard,
    cards,
    selectedCard,
  };
};

export { useSelectCard };
